export default __webpack_public_path__ + "static/media/5G-pos.b418550d.svg";